import React, { Component } from "react";
import { connect } from "react-redux";
import { notificationActions } from "../modules/notifications";
import Notification from "../components/Notification";
import styles from "../styles/components/NotificationContainer.css";

/**
 * <Notification type="error" message={loginStatus.error.errorMessage}/>
 */
class NotificationContainer extends Component {
    static DEFAULT_DISMISS_INTERVAL = 5000; //TODO: More potential config variables

    remove(notificationId) {
        this.props.removeNotification(notificationId);
    }

    render() {
        const { style, notifications } = this.props;
        return (
            <div className={styles.container} style={style}>
                {notifications.map(notification => (
                    <Notification
                        key={notification.id}
                        level={notification.level}
                        message={notification.message}
                        icon={notification.icon || null}
                        button={notification.button || null}
                        dismiss={this.remove.bind(this, notification.id)}
                        dismissInterval={
                            NotificationContainer.DEFAULT_DISMISS_INTERVAL
                        }
                    />
                ))}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        notifications: state.notifications || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        removeNotification: notificationId =>
            dispatch(notificationActions.removeNotification(notificationId))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationContainer);



// WEBPACK FOOTER //
// ./src/containers/NotificationContainer.js